import tw from 'twin.macro';
import styled from 'styled-components';

export const Section = tw.div`
  bg-white py-24 sm:py-24
`;

export const Container = tw.div`
  mx-auto max-w-7xl px-6 lg:px-8
`;

export const Heading = tw.h2`
  text-5xl tracking-tight text-center mb-5
`;

export const Grid = tw.dl`
  grid grid-cols-1 my-10 gap-x-8 gap-y-16 text-center lg:grid-cols-3
`;

export const StatCard = styled.div`
  ${tw`  flex max-w-xl flex-col gap-y-4 border-r border-l border-gray-300`}
  &:last-child {
    ${tw`lg:col-span-3 ps-28 pe-28 text-center sm:mx-auto`} 
  }
`;

export const StatTitle = tw.dt`
  text-base  uppercase text-gray-600
`;

export const StatValue = tw.dd`
  order-first text-3xl  tracking-tight text-gray-900 sm:text-5xl
`;
